<template>
  <div class="comp-notice-wrap" :style="{zIndex}" ref="noticeWrap">
    <transition name="comp-notice" @after-leave="removeDom($refs.noticeWrap)">
      <div class="comp-notice" v-if="visible"
           @click="close"
           :class="[type]">
        {{message}}
      </div>
    </transition>
  </div>
</template>

<script>
  /**
   * @author shaojingchao
   * @date 2018/12/7
   * @project kaoshizhongxin
   * @desc
   */
  export default {
    name: 'comp-notice',
    props: {},
    data () {
      return {
        zIndex: 0,
        visible: false,
        message: '提示',
        type: ''
      }
    },
    methods: {
      removeDom (wrap) {
        if (wrap.parentNode) {
          wrap.parentNode.removeChild(wrap)
          this.$_remove()
        }
      },
      close () {
        this.visible = false
        clearTimeout(this.$_timer)
      }
    }
  }
</script>

<style lang="less">
  .comp-notice-wrap {
    position: fixed;
    top:40px;
    right:0;
    left:0;
    height:50px;
    display: flex;
    justify-content: center;
    .comp-notice {
      position: absolute;
      left: 50%;
      top: 0;
      color:#fff;
      background-color: rgba(0,0,0,.5);
      padding: 10px;
      min-width:200px;
      line-height: 1;
      text-align: center;
      font-size: 13px;
      border-radius: 5px;
      /*border:1px solid #00AAFF;*/
      transition: all 0.3s;
      transform: translate(-50%, 0);
      box-shadow: 0 3px 5px rgba(0,0,0,.03);
      &-enter, &-leave-to {
        opacity: 0;
        transform: translate(-50%, -100px) ;
      }
      &.primary {
        border-color: rgba(17, 149, 238, .8);
      }
      &.success {
        border-color: rgba(0, 201, 109, .8);
      }
      &.warning {
        border-color: rgba(220, 140, 0, .8);
      }
      &.error {
        border-color: rgba(255, 61, 60, .8);
      }
    }
  }
</style>
